import { render, staticRenderFns } from "./SharedProductCategorie.template.vue?vue&type=template&id=166e3eaa&scoped=true&"
var script = {}
import style0 from "./SharedProductCategorie.template.vue?vue&type=style&index=0&id=166e3eaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e3eaa",
  null
  
)

export default component.exports